import React from 'react';
import PropTypes from 'prop-types';

import ParentButtonComponent from './ParentButtonComponent';

class ButtonComponent extends React.Component {
    render() {
        const { disabled, id, type = 'button', color, cssClass, text, onClick, attrs } = this.props;
        const attr = { disabled, id, type, onClick, ...attrs };
        return (
            <ParentButtonComponent tag="button" color={color} cssClass={cssClass} attr={attr}>
                {text}
            </ParentButtonComponent>
        );
    }
}

ButtonComponent.propTypes = {
    type: PropTypes.oneOf(['button', 'submit']),
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    color: PropTypes.string.isRequired,
    cssClass: PropTypes.string,
    id: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    attrs: PropTypes.array
};

export default ButtonComponent;



// WEBPACK FOOTER //
// ./src/components/button/ButtonComponent.js